// tslint:disable max-line-length
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Block from 'lqa-ui/lib/Components/Block';
import ChartTrend from 'lqa-ui/lib/Applications/Admin/Components/ChartTrend';
import Icon from 'lqa-ui/lib/Components/Icon';
import './styles.scss';
import { getItem, setItem } from '../../utils/localStorage';
import { useNavigate, useLocation } from 'react-router-dom';
import { topBottom, getTrendScore } from './apiCaller';
import { assessments as assessmentApi } from '../Dashboard/apiCaller';
import Slider from 'infinite-react-carousel';
import { ResponsiveContainer } from 'recharts';
import '../../style/main.scss';
import HotelAssessmentSelection from '../../components/commons/Header/HotelAssessmentSelection';
import Skeleton from 'react-loading-skeleton';
import { pressAndHoldMenu } from '../../components/commons/PressAndHold';
import { AssessmentSummaryAPI } from './../../requests/benchmarking';
import { getDepartmentApi } from '../SelfAssessmentAssignDepartment/apiCaller';
import { showErrorMessage } from '../../helpers/showMessage';
import noResults from '../../../www/assets/svg/noResults.svg';
import { isUnauthorized } from '../../utils/common';
import PendingAssessment from '../commons/PendingAssessment';
import { gethasAssessment } from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';

const TrendingScoresContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  width: 100%;
`;

const ContentArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 240px;
  padding-bottom: 88px;
`;

const TrendingScores = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const l: any = { ...location };

  const { state } = l;

  if (!l.state) {
    return <></>;
  }

  const userData = getItem('user');
  const isSubDepartmentUser =
    userData && userData.user && userData.user.userType === 'subDepartment';
  const [toggle, setToggle] = useState(true);
  const [selectedHotel, setSelectedHotel] = useState(getItem('selectedHotel'));
  const [selectedClient, setSelectedClient] = useState(
    getItem('selectedClient')
  );
  const [assessments, setAssessments] = useState<
    {
      stayStart: string;
      id: number;
    }[]
  >([]);
  const [selectedAssessment, setSelectedAssessment] = useState<string | undefined>(undefined);
  const [topBottomScores, setTopBottomScores] = useState<
    | {
      topDepartments: any[];
      bottomDepartments: any[];
    }
    | undefined
  >(undefined);
  const [standard, setStandard] = useState(
    state && state.standard ? state.standard : 'LQA'
  );
  const [chartData, setChartData] = useState<any[] | undefined>(undefined);
  const [openPressAndHold, setOpenPressHold] = useState(false);
  const [pressHoldData, setPressHoldData] = useState<any>({
    sourceCategoryId: null,
    visit: null,
  });
  const [apiData, setApiData] = useState<
    | {
      data: any[];
      overall: any;
    }
    | undefined
  >(undefined);
  const [tempData, setTempData] = useState<{ data: any[] } | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCompset, setSelectedCompset] = useState(state.selectedCompset);
  const compsetData = state.compsetData;
  const [selectedCompsetName, setSelectedCompsetName] = useState(
    state.selectedCompsetName
  );
  const [hasAssessment, setHasAssessment] = useState(gethasAssessment());

  useEffect(() => {
    if (selectedAssessment && hasAssessment) {
      AssessmentSummaryAPI(selectedAssessment)
        .then((res) => {
          setApiData(res);
          getDepartmentApi()
            .then((responseData) => {
              setTempData(responseData.data);
            })
            .catch((error) => {
              showErrorMessage(
                'Could not load department data',
                !isUnauthorized(error)
              );
            });
        })
        .catch((err) => {
          showErrorMessage(
            'Unable to retrieve Assessment summary',
            !isUnauthorized(err)
          );
        });
    }
  }, [selectedAssessment, hasAssessment]);

  useEffect(() => {
    if (state && state.hotelId) {
      const hotel = getItem('selectedHotel');
      setSelectedHotel(hotel ? hotel : state.hotelId);
      setItem('selectedHotel', hotel ? hotel : state.hotelId);
      setItem('selectedBrand', state.brandId);
    } else {
      const hotel = getItem('selectedHotel');
      setSelectedHotel(hotel ? hotel : userData.user.brands[0].hotels[0].id);
      setItem(
        'selectedHotel',
        hotel ? hotel : userData.user.brands[0].hotels[0].id
      );
      setItem('selectedBrand', userData.user.brands[0].id);
    }
  }, []);

  useEffect(() => {
    assessmentApi().then((response) => {
      setAssessments(response);
      const selectedAssessmentIfAny = response.find(
        (bK) => bK.stayStart === state.selectedAssessment
      );
      const assess = response.find(
        (o) => o.stayStart === getItem('selectedAssessmentDate')
      )
        ? getItem('selectedAssessmentDate')
        : undefined;
      setSelectedAssessment(
        assess
          ? assess
          : selectedAssessmentIfAny
            ? selectedAssessmentIfAny.stayStart
            : response[0].stayStart
      );
    });
  }, [selectedHotel, selectedClient]);

  useEffect(() => {
    if (selectedAssessment && hasAssessment) {
      topBottom(selectedAssessment).then((res) => {
        setTopBottomScores(res);
      });
      setChartData(undefined);
      getTrendScore(
        standard,
        selectedCompset,
        'all',
        'all'
      ).then((res) => setChartData(res));
    }
  }, [
    selectedAssessment,
    standard,
    selectedCompset,
    selectedHotel,
    selectedClient,
  ]);

  useEffect(() => {
    if (selectedCompset && compsetData && compsetData.length && hasAssessment) {
      const compset = compsetData.find(
        (o) => o.compSetNumber.toString() === selectedCompset.toString()
      );
      if (compset) {
        setSelectedCompsetName(compset.compSetName);
      }
    }
  }, [selectedCompset, hasAssessment]);

  if (!hasAssessment) {
    return (
      <PendingAssessment
        assessments={assessments}
        setAssessments={setAssessments}
        selectedHotel={selectedHotel}
        setSelectedHotel={setSelectedHotel}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        selectedAssessment={selectedAssessment}
        setSelectedAssessment={setSelectedAssessment}
        isSelectDate={true}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        lqaCompset={compsetData}
        selectedCompset={selectedCompset}
        setSelectedCompset={setSelectedCompset}
        hasAssessment={hasAssessment}
        setHasAssessment={setHasAssessment}
      />
    );
  }

  return (
    <TrendingScoresContainer>
      <div className="header">
        <AppHeader />
        <HotelAssessmentSelection
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={isLoading}
          lqaCompset={compsetData}
          setIsLoading={setIsLoading}
          selectedCompset={selectedCompset}
          setSelectedCompset={setSelectedCompset}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </div>
      {!topBottomScores ||
        !topBottomScores.topDepartments ||
        !topBottomScores.bottomDepartments ||
        !chartData ||
        !selectedAssessment ? (
        <ContentArea>
          <div className="box-shadow d-block">
            <div className="m-10 mb-10">
              <Skeleton
                containerClassName="flex-1"
                height={35}
                borderRadius={5}
              />
              <Skeleton
                containerClassName="flex-1"
                height={20}
                borderRadius={5}
              />
              <div className="mt-10 mb-10">
                <Skeleton
                  containerClassName="flex-1"
                  height={50}
                  borderRadius={5}
                />
              </div>
              <div className="row-separater-skeleton mb-20">
                <Skeleton width={140} height={50} borderRadius={5} />
                <Skeleton width={140} height={50} borderRadius={5} />
              </div>
              <Skeleton
                containerClassName="flex-1"
                height={300}
                borderRadius={5}
              />
              <Skeleton
                containerClassName="flex-1"
                height={150}
                borderRadius={5}
              />
            </div>
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          <Block className="noShadow">
            <h1>Hotel Trending Report</h1>
            <span className="subHeading">
              Data shows a comparison to competing hotels
            </span>
          </Block>
          <Block>
            <div>
              {chartData.length > 0 && (
                <Slider dots={true} dotsClass={'carousel-dots'} arrows={false}>
                  {chartData.map((chartD) => (
                    // tslint:disable-next-line:jsx-key
                    <div>
                      <ResponsiveContainer
                        minWidth={280}
                        width="100%"
                        height={300}
                      >
                        <ChartTrend data={chartD.scores} />
                      </ResponsiveContainer>
                      <p>{selectedCompsetName}</p>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </Block>
          <Block className="deptPerformanceContainer">
            <h3 className="subHeadingH3 sans-font fw-600 f-20 lh-24 color-black">
              Department Performance
            </h3>
            <span className="fw-400 f-15 lh-20 color-717171">
              Compared to competitive set average.
            </span>
            <div className="sortContainer">
              <div
                className={`${toggle ? 'iconTrending' : 'iconTrending hide'}`}
              >
                <Icon kind="trending-up" height={20} width={20} />
              </div>
              <div
                className={`${toggle === false ? 'iconTrending' : 'iconTrending hide'}`}
              >
                <Icon kind="trending-down" height={20} width={20} />
              </div>
              <div
                className={`${toggle ? 'sortLow' : 'sortLow activeSort'}`}
                onClick={() => setToggle(false)}
              >
                Lowest
              </div>
              <div
                className={`${toggle === false ? 'sortHigh' : 'sortHigh activeSort'}`}
                onClick={() => setToggle(true)}
              >
                Highest
              </div>
            </div>
            <Block className="deptPerformanceTableContainer">
              <div
                className={`fw-600 f-17 lh-22 pl-10 ${toggle ? 'color-58C3BB' : 'color-CC3044'}`}
              >
                {' '}
                {toggle ? 'Highest Departments' : 'Lowest Departments'}{' '}
              </div>
              <div
                className={`${toggle ? 'performanceHigh' : 'performanceHigh hide'
                  }`}
              >
                <table className="deptPerformance">
                  <tr className="fw-600 f-12 lh-16">
                    <th>Department</th>
                    <th>Perf</th>
                    <th>Diff</th>
                    {!isSubDepartmentUser && <th />}
                  </tr>
                  {topBottomScores &&
                    topBottomScores.topDepartments &&
                    topBottomScores.topDepartments.length ? (
                    topBottomScores.topDepartments.map((top) => {
                      return (
                        // tslint:disable-next-line:jsx-key
                        <tr className="fw-400 f-15 lh-20">
                          <td>{top.name}</td>
                          <td className="fw-600">{top.score}%</td>
                          <td>{top.difference}</td>
                          {!isSubDepartmentUser && (
                            <td>
                              <Icon
                                kind="edit-diary"
                                height={15}
                                width={15}
                                onClick={() => {
                                  setPressHoldData(top);
                                  setOpenPressHold(true);
                                }}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <div className="NoResults">
                          <img src={noResults} className="noResults" />
                          <span className="sans-font gap-15 fw-bold lh-22 noResultFont">
                            Your assigned department is not on this list
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </table>
              </div>
              <div
                className={`${toggle === false ? 'performanceLow' : 'performanceLow hide'
                  }`}
              >
                <table className="deptPerformance">
                  <tr className="fw-600 f-12 lh-16">
                    <th>Department</th>
                    <th>Perf</th>
                    <th>Diff</th>
                    {!isSubDepartmentUser && <th />}
                  </tr>
                  {topBottomScores &&
                    topBottomScores.bottomDepartments &&
                    topBottomScores.bottomDepartments.length ? (
                    topBottomScores.bottomDepartments.map((top) => {
                      return (
                        // tslint:disable-next-line:jsx-key
                        <tr className="fw-400 f-15 lh-20">
                          <td>{top.name}</td>
                          <td className="fw-600">{top.score}%</td>
                          <td>{top.difference}</td>
                          {!isSubDepartmentUser && (
                            <td>
                              <Icon
                                kind="edit-diary"
                                height={15}
                                width={15}
                                onClick={() => {
                                  setPressHoldData(top);
                                  setOpenPressHold(true);
                                }}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <div className="NoResults">
                          <img src={noResults} className="noResults" />
                          <span className="sans-font gap-15 fw-bold lh-22 noResultFont">
                            Your assigned department is not on this list
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </Block>
          </Block>
        </ContentArea>
      )}
      {pressAndHoldMenu(
        pressHoldData,
        setOpenPressHold,
        openPressAndHold,
        selectedAssessment,
        tempData,
        apiData,
        navigate
      )}
    </TrendingScoresContainer>
  );
};

export default TrendingScores;
